/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Plan_VisitInputs */

const en_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan your visit.`)
};

const es_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planea tu visita.`)
};

const de_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planen Sie Ihren Besuch.`)
};

const zh_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`规划你的到访。`)
};

const ar_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطّط لزيارتك.`)
};

const fr_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planifiez votre visite.`)
};

const vi_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lên kế hoạch ghé thăm.`)
};

const sw_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panga ziara yako.`)
};

const th_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วางแผนการเยี่ยมชมของคุณ`)
};

const bs_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isplanirajte posjetu.`)
};

const ja_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご来店をお待ちしております。`)
};

const ko_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방문을 계획하세요.`)
};

const pt_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planeje sua visita.`)
};

const it_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizza la tua visita.`)
};

const sv_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planera ditt besök.`)
};

const nl_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan je bezoek.`)
};

const da_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlæg dit besøg.`)
};

const nb_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlegg ditt besøk.`)
};

const fi_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suunnittele vierailusi.`)
};

const pl_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaplanuj wizytę.`)
};

const ru_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Планируйте свой визит.`)
};

const tr_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziyaretinizi planlayın.`)
};

const hi_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी यात्रा की योजना बनाएं।`)
};

const id_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencanakan kunjungan Anda.`)
};

const ms_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rancang lawatan anda.`)
};

const cs_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naplánuj si návštěvu.`)
};

const el_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σχεδιάστε την επίσκεψή σας.`)
};

const he_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תכננו את הביקור שלכם.`)
};

const af_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beplan jou besoek.`)
};

const hu_range_plan_visit = /** @type {(inputs: Range_Plan_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tervezd meg a látogatást.`)
};

/**
* | output |
* | --- |
* | "Plan your visit." |
*
* @param {Range_Plan_VisitInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_plan_visit = /** @type {((inputs?: Range_Plan_VisitInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Plan_VisitInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_plan_visit(inputs)
	if (locale === "de") return de_range_plan_visit(inputs)
	if (locale === "zh") return zh_range_plan_visit(inputs)
	if (locale === "ar") return ar_range_plan_visit(inputs)
	if (locale === "fr") return fr_range_plan_visit(inputs)
	if (locale === "vi") return vi_range_plan_visit(inputs)
	if (locale === "sw") return sw_range_plan_visit(inputs)
	if (locale === "th") return th_range_plan_visit(inputs)
	if (locale === "bs") return bs_range_plan_visit(inputs)
	if (locale === "ja") return ja_range_plan_visit(inputs)
	if (locale === "ko") return ko_range_plan_visit(inputs)
	if (locale === "pt") return pt_range_plan_visit(inputs)
	if (locale === "it") return it_range_plan_visit(inputs)
	if (locale === "sv") return sv_range_plan_visit(inputs)
	if (locale === "nl") return nl_range_plan_visit(inputs)
	if (locale === "da") return da_range_plan_visit(inputs)
	if (locale === "nb") return nb_range_plan_visit(inputs)
	if (locale === "fi") return fi_range_plan_visit(inputs)
	if (locale === "pl") return pl_range_plan_visit(inputs)
	if (locale === "ru") return ru_range_plan_visit(inputs)
	if (locale === "tr") return tr_range_plan_visit(inputs)
	if (locale === "hi") return hi_range_plan_visit(inputs)
	if (locale === "id") return id_range_plan_visit(inputs)
	if (locale === "ms") return ms_range_plan_visit(inputs)
	if (locale === "cs") return cs_range_plan_visit(inputs)
	if (locale === "el") return el_range_plan_visit(inputs)
	if (locale === "he") return he_range_plan_visit(inputs)
	if (locale === "af") return af_range_plan_visit(inputs)
	if (locale === "hu") return hu_range_plan_visit(inputs)
	return en_range_plan_visit(inputs)
});